import Template from 'backbone/platform/templates/assets/picker.js.hamlc'
import AssetPickerActionsView from 'backbone/platform/views/assets/asset_picker_actions_view.js'
import BackboneDispatcher from 'lib/backbone_dispatcher.js'
import {VALID_FILE_TYPES} from 'app/utils/fileUploadValidator.js'
export default class BaseAssetPickerView extends Backbone.View
  template: Template

  events:
    "dragover .assets-droparea"       : "dragover"
    "dragleave .drag-drop-tint"       : "dragleave"
    "drop .drag-drop-tint"            : "dragleave"
    "click .toggles"                  : "handleTabClick"

  initialize: (options) ->
    @_setupDispatcher()
    @options = options
    @assetsPickedCallback = @options.assetsPicked
    @setupAcceptedFormats()
    @render()

    contently.ui.showModal("asset-picker-modal")
    $("#asset-picker-modal").on("modal:afterClose", @closeModal)

  render: ->
    @_cleanupSubviews()
    @subviews = []

    @_attachTemplate()

    if @options.mediaLibraryAccess
      @_renderCollection()
      @_renderActions()

    @$dragDropTint = @$(".drag-drop-tint")

  handleTabClick: (event) ->
    activeTab = $(event.target).data("target")
    @_toggleActiveTab(activeTab)

  determineActiveTab: (collection) =>
    activeTab = if collection.size() > 0 then "choose" else "upload"
    @_toggleActiveTab(activeTab)

  dragover: ->
    @$dragDropTint.removeClass('hidden')

  dragleave: ->
    @$dragDropTint.addClass('hidden')

  closeModal: =>
    @$el.empty().off()
    @_cleanupSubviews()
    @_teardownDispatcher()
    @_teardownAcceptedFormats()

  _setupDispatcher: ->
    @dispatcher = BackboneDispatcher.get_instance()
    @dispatcher.bind("collectionLoaded", @determineActiveTab)

  _teardownDispatcher: ->
    @dispatcher.unbind("collectionLoaded")

  _teardownAcceptedFormats: -> $("#asset_uploader_input").attr("accept", null)

  setupAcceptedFormats: ->
    # Capture the value set on the input itself
    existing = $("#asset_uploader_input").attr("accept")

    # Throw an error if we are setting two different values
    # in separate places
    throw "Accepted formats conflict" if (existing && @options.acceptedFormats && existing != @options.acceptedFormats)

    # Set the supplied format via options, then existing or to nothing
    $("#asset_uploader_input").attr("accept", @options.acceptedFormats || existing || VALID_FILE_TYPES)

  _cleanupSubviews: ->
    if @subviews
      _.each @subviews, (subview) ->
        subview.remove()
      delete @subviews

  _renderActions: ->
    @actionsView = new AssetPickerActionsView(el: @$('#actions-container'))
    @subviews.push(@actionsView)

  _toggleActiveTab: (activeTab) ->
    if activeTab == "choose"
      $("#modal-tab1").show()
      $("#modal-tab2").hide()
      $(".tab1").addClass("active")
      $(".tab2").removeClass("active")
      $("#actions-container").show()
    else if activeTab == "upload"
      $("#modal-tab1").hide()
      $("#modal-tab2").show()
      $(".tab1").removeClass("active")
      $(".tab2").addClass("active")
      $("#actions-container").hide()



// WEBPACK FOOTER //
// ./app/javascript/backbone/platform/views/assets/base_asset_picker_view.js.coffee